import $ from 'jquery';

import row from './row/row'

export default function(o,p){

  o.currentData = null

  var totalParts = null
  var currentPart = null

  var addPart = function(part){

    var begin = (part - 1) * 100
    var end = begin + 100

    console.log('addPart', part, begin, end)

    div
    .append(
      _.map(
        o.currentData.slice(begin,end),
        function(r,i){
          return row(o,r)
        },
      )
    )

    p.layout()

  }

  var update = function(data){

    console.log('update')

    o.currentData = data

    currentPart = o.store('tableStartupPart_'+p.modelId)

    if(!currentPart){
      currentPart = 1
    }

    totalParts = Math.ceil(data.length / 100)

    div.empty()

    for (let index = 1; index <= currentPart; index++) {
      addPart(index)
    }

    var currentScroll = o.store('tableStartupScroll_'+p.modelId)

    if(!currentScroll){
      currentScroll = 0
    }

    div.scrollTop(currentScroll)

  }

  var scroll =
    function(e){

      var containerHeight = div.height()
      var contentHeight = div[0].scrollHeight
      var maxScroll = contentHeight - containerHeight
      var currentScroll = div.scrollTop()
      var partHeight = contentHeight / currentPart

      o.store('tableStartupScroll_'+p.modelId,currentScroll)

      var startupPart = Math.round(currentScroll/partHeight) + 1
      o.store('tableStartupPart_'+p.modelId,startupPart)

      if(maxScroll < currentScroll + 100 && currentPart < totalParts){
        currentPart ++
        addPart(currentPart)
      }

    }

  var div =
    $('<div>')
    .css({
      display: 'block',
      position: 'absolute',
      overflowY: 'scroll',
      borderCollapse: 'collapse',
      top: '68px',
      bottom: 0,
      left: 0,
      right: 0,
    })

  div.update = update

  div.scroll(_.debounce(scroll,100))

  return div;

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/rows/rows.js